import { render, staticRenderFns } from "./WaterfallChart.vue?vue&type=template&id=b32bf064&scoped=true&"
import script from "./WaterfallChart.vue?vue&type=script&lang=ts&"
export * from "./WaterfallChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32bf064",
  null
  
)

export default component.exports